import { useAuth } from '@clerk/clerk-react';
import Intercom from '@intercom/messenger-js-sdk';
import { ZeroProvider } from '@rocicorp/zero/react';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { HotkeysProvider } from 'react-hotkeys-hook';
import { z } from 'zod';

import { createZeroInstance } from '@/lib/zero';
import { useAuthContext } from '@/services/auth-context';
import { userQuery, useUser } from '@/services/user';

export const Route = createFileRoute('/_authed')({
  component: () => <MainLayout />,
  validateSearch: zodValidator(z.object({ state: z.string().optional() })),
  beforeLoad: async ({ context: { isSignedIn, queryClient, userId, getToken }, search: { state } }) => {
    // this redirects to the correct origin for development github app
    console.log(isSignedIn, location.pathname);
    const stateData = state
      ? z.object({ redirectUrl: z.string(), origin: z.string() }).parse(JSON.parse(atob(state)))
      : null;
    if (stateData) {
      if (stateData.origin && stateData.origin !== window.location.origin) {
        console.log('redirecting to origin', stateData.origin, window.location.pathname, window.location.search);
        window.location.href = `${stateData.origin}${window.location.pathname}${window.location.search}`;
      }
    }

    if (!isSignedIn) {
      console.log('Not signed in, redirecting to sign-in');
      throw redirect({ to: '/sign-in/$', search: location.pathname !== '/' ? { redirectTo: location.pathname } : {} });
    }
    const user = await queryClient.ensureQueryData(userQuery);

    return { user };
  },
  loader: async ({ context: { user } }) => {
    return { user };
  },
});
const INTERCOM_APP_ID = 'c7w862x5';

export const MainLayout = () => {
  const { userId, getToken } = useAuth();
  const { user } = useUser();
  const authContext = useAuthContext();

  useEffect(() => {
    Intercom({
      app_id: INTERCOM_APP_ID,
      custom_launcher_selector: '#mesa-support-button',
      hide_default_launcher: true,
      user_id: user.id.toString(),
      name: user.name ?? undefined,
      email: user.email ?? undefined,
      created_at: user.created_at ? new Date(user.created_at).getTime() / 1000 : undefined,
    });
  }, [user]);

  return (
    <ZeroProvider zero={createZeroInstance(userId!, getToken, authContext)}>
      <HotkeysProvider>
        <Outlet />
      </HotkeysProvider>
    </ZeroProvider>
  );
};
